import clsx from 'clsx';
import { FC, useEffect, useState } from 'react';

import sanitizeHtml from 'sanitize-html';

import styles from './privacy.module.scss';
import { IPrivacyProps } from './types';

import { Loader } from 'src/components/ui';
import { getPrivacy, sanitizeOptions } from '~utils';

export const Privacy: FC<IPrivacyProps> = ({ className = '', ...rest }) => {
  const [privacyText, setPrivacyText] = useState('');

  useEffect(() => {
    getPrivacy('policy').then(data => {
      setPrivacyText(data);
    });
  }, []);

  return (
    <div className={clsx(styles.container, className)} {...rest}>
      {privacyText ? (
        <div
          className={styles.content}
          dangerouslySetInnerHTML={{ __html: sanitizeHtml(privacyText, sanitizeOptions) }}
        />
      ) : (
        <Loader />
      )}
    </div>
  );
};
